import { useEffect, useRef } from 'react'

export const useKeyPress = (targetKey: string, handler: (event: KeyboardEvent) => void): void => {
  const handlerRef = useRef(handler)

  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    const downHandler = (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        handlerRef.current(event)
      }
    }

    window.addEventListener('keydown', downHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  }, [targetKey])
}
